import * as React from "react";
import { connect } from "react-redux";
import { Select } from "antd";
const Option = Select.Option;

interface IProps {
  value?: any;
  field?: any;
  modelName?: any;
  onChange?: any;
  setValue?: any;
  width?: any;
  placeholder?: any;
  share?: any;
}

interface ISelectorData {
  id: string;
  name: string;
}

interface ISelectorProps extends IProps {
  // 数据源
  data?: [ISelectorData];
  // 数据源名称（匹配异步接口）
  selectorName?: any;
  // 异步数据，供应商接口(由reudx提供)
  getSupplier?: any;
  // 异步数据，商品分类列表接口(由reudx提供)
  getProductCate?: any;
  // 异步数据，客服列表接口(由reudx提供)
  getUser?: any;
  // 异步数据，获取商城订单来源接口(由reudx提供)
  getStoreOrderSource?: any;
  // 售后原因
  getAfterSaleReson?: any;
  // 售后类型
  getAfterSaleType?: any;
  onRef?: any;
  onChange: any;
  isMultiple?: any;
}

// 下拉列表组件
class Selector extends React.Component<ISelectorProps, any> {
  state = {
    // 当前选中的值
    value: [],
    data: []
  };

  constructor(props: ISelectorProps) {
    super(props);
    this.props.onRef && this.props.onRef(this);
  }

  //componentWillMount() {
  componentDidMount() {
    if (!this.props.data && this.props.selectorName) {
      switch (this.props.selectorName) {
        // 供应商列表
        case "supplier":
          this.props.getSupplier();
          break;
        // 商品分类列表
        case "productCate":
          this.props.getProductCate();
          break;
        // 客服列表
        case "user":
          this.props.getUser();
          break;
        // 商城订单来源列表
        case "storeOrderSource":
          this.props.getStoreOrderSource();
          break;
        // 获取售后原因
        case "getAfterSaleReson":
          this.props.getAfterSaleReson();
          break;
        // 获取售后类型
        case "getAfterSaleType":
          this.props.getAfterSaleType();
          break;
        default:
          break;
      }
    }
  }

  onChange = value => {
    this.setState({
      value
    });

    this.props.onChange(value);
  };

  getMode = () => {
    if (this.props.isMultiple) {
      return "multiple";
    } else {
      return undefined;
    }
  };

  render() {
    let data: any = [];
    if (!this.props.data && this.props.selectorName) {
      data = this.props.share[this.props.selectorName] || [];
    } else {
      data = this.props.data || [];
    }
    // 遍历数据项
    let getData: any = () => {
      let options: any = [];
      data.forEach((item, index) => {
        // 验证数据格式
        if (!(item && item.id && item.name)) {
          console.warn(
            "格式错误",
            item,
            " 传递给Selector的数据格式应该如此：",
            [{ id: "XXX", name: "XXX" }]
          );
        } else {
          options.push(
            <Option key={index} value={item.id}>
              {item.name}
            </Option>
          );
        }
      });

      return options;
    };

    // 当数据已加载完成时才设置选中的值,这样处理可以避免由于数据集加载而造成的闪烁
    // let value = undefined;

    // if (data) {
    //   value = data.length ? this.props.value || undefined : undefined;
    // }

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
      <Select
        placeholder={this.props.placeholder || "选择一项"}
        style={{ width: this.props.width || 140 }}
        allowClear={true}
        // 检索相关
        showSearch
        optionFilterProp="children"
        filterOption={filter}
        onChange={this.onChange}
        mode={this.getMode()}
        // 检索相关
      >
        {getData()}
      </Select>
    );
  }
}

const mapState = state => ({
  share: state.share
});

const mapDispatch = dispatch => {
  return {
    getSupplier: dispatch.selectorSource.getSupplier,
    getProductCate: dispatch.selectorSource.getProductCate,
    getUser: dispatch.selectorSource.getUser,
    getStoreOrderSource: dispatch.selectorSource.getStoreOrderSource,
    getAfterSaleReson: dispatch.selectorSource.getAfterSaleReson,
    getAfterSaleType: dispatch.selectorSource.getAfterSaleType
  };
};

export default connect(
  mapState,
  mapDispatch
)(Selector);
